import dayjs from 'dayjs';

export const createCopyrightString = () => `© SIMPLEWINE, ${dayjs().year()}`;
